import { render, staticRenderFns } from "./ReturnOrders.html?vue&type=template&id=59614959&external"
import script from "./ReturnOrders.js?vue&type=script&lang=js&external"
export * from "./ReturnOrders.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports